export class proposalResMdl {
    public proposalNo: string;
    public EproposalNo: string;
    public TotalPremium: string;
    public RegNo: string;
    public InsuredName: string;
    public MobileNo: string;
    public Email: string;
    public PMethod: string;
    public EncPayInfo: string;
    public PaySig: string;
    public ProductCode: string;
    public st: FortStatusMdl = new FortStatusMdl();
    public BankCode: string;
    public IBAN: string;
    public IBAN1: string;
    public IBAN2: string;
    public IBAN3: string;
    public IBAN4: string;
    public IBAN5: string;
    public IBAN6: string;
}
export class FortStatusMdl {
    public StatusCode: string;
    public StatusDesc: string;
    public StatusDescAr: string;
    public msgKey: string;
    public Result: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/proposalResMdl.ts